import { Box } from "@mui/system";
import React, { FC } from "react";

interface Props {
  sx?: any;
  children: React.ReactNode;
}

const StaticPagesLayout: FC<Props> = (props: Props) => {
  return <Box sx={props.sx}>{props.children}</Box>;
};

export default StaticPagesLayout;
